import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { componentFields, componentTypes } from 'apps/analytics';
import PageComponent from 'apps/analytics/components/PageComponent';
import PageComponentField from 'apps/analytics/components/PageComponentField';

const getComponentId = (sku) => `TrolleyItem.${sku}`;

export default class TrolleyItemsPageComponents extends PureComponent {
  static propTypes = {
    items: PropTypes.array.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    location: PropTypes.object.isRequired, // Force re-render on location change
  };

  static getItemContent = item => (
    <PageComponent
      id={getComponentId(item.sku)}
      type={componentTypes.FOP_BASKET}
      key={item.sku}
    >
      <PageComponentField field={componentFields.SKU} value={item.sku} />
    </PageComponent>
  );

  render() {
    const { items } = this.props;

    if (!items.length) {
      return null;
    }

    return [items.map(TrolleyItemsPageComponents.getItemContent)];
  }
}
